'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.renderEdges = exports.renderEdge = exports.renderNode = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDnd = require('react-dnd');

var _reactDom = require('react-dom');

var _xtend = require('xtend');

var _xtend2 = _interopRequireDefault(_xtend);

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

var _pureGraph = require('pure-graph');

var _utils = require('utils/utils');

var _functional = require('utils/functional');

var _sceneUtils = require('./sceneUtils');

var _projectDragItemTypes = require('./projectDragItemTypes');

var _projectDragItemTypes2 = _interopRequireDefault(_projectDragItemTypes);

var _NodeView = require('./NodeView');

var _NodeView2 = _interopRequireDefault(_NodeView);

var _EdgeView = require('./EdgeView');

var _EdgeView2 = _interopRequireDefault(_EdgeView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./ProjectScene.pcss');

var APPEND_RIGHT_PADDING = 112;
var APPEND_BOTTOM_PADDING = 96;

var getDroppableNodes = function getDroppableNodes(nodeId, graphData) {
  var nodes = (0, _pureGraph.getNodes)(graphData);
  var isDetached = (0, _pureGraph.getEdgesIncidentToNode)(nodeId, graphData).length === 0;
  if (isDetached) return nodes;

  return nodes.filter(function (node) {
    if (node === nodeId) return false;

    var isNodeDetached = (0, _pureGraph.getEdgesIncidentToNode)(node, graphData).length === 0;
    if (isNodeDetached) return true;

    var graphToCheck = (0, _functional.compose)((0, _pureGraph.addEdge)((0, _utils.guid)(), nodeId, node), (0, _pureGraph.removeEdgesToNode)(nodeId))(graphData);

    return !(0, _pureGraph.hasCyclesInConnectedComponent)(nodeId, graphToCheck);
  });
};

var renderNode = exports.renderNode = function renderNode(_ref) {
  var id = _ref.id;
  var _ref$data = _ref.data;
  var x = _ref$data.x;
  var y = _ref$data.y;
  var caption = _ref$data.caption;
  var color = _ref$data.color;
  var isNodeBeingDragged = _ref.isNodeBeingDragged;
  var isPreviewing = _ref.isPreviewing;
  var onPositionUpdate = _ref.onPositionUpdate;
  var onCaptionUpdated = _ref.onCaptionUpdated;
  var onRemove = _ref.onRemove;
  var onBoundingRectUpdate = _ref.onBoundingRectUpdate;
  var onHover = _ref.onHover;
  var onHoverStop = _ref.onHoverStop;
  var onEdgeConnectionRequest = _ref.onEdgeConnectionRequest;
  var onPreview = _ref.onPreview;
  var onColorUpdate = _ref.onColorUpdate;
  var onDetach = _ref.onDetach;
  var onAppendNew = _ref.onAppendNew;
  var onAppendRight = _ref.onAppendRight;
  var onAppendRightConnected = _ref.onAppendRightConnected;
  var onAppendBottomConnected = _ref.onAppendBottomConnected;
  var onBeginDrag = _ref.onBeginDrag;
  var onBeginDragSubtree = _ref.onBeginDragSubtree;
  var onEndDrag = _ref.onEndDrag;
  var onEndDragSubtree = _ref.onEndDragSubtree;
  var canBeDropTarget = _ref.canBeDropTarget;
  var onNodeOver = _ref.onNodeOver;
  var onNodeOverStop = _ref.onNodeOverStop;
  var disableModifications = _ref.disableModifications;
  var editOnMount = _ref.editOnMount;
  return _react2.default.createElement(_NodeView2.default, {
    key: id,
    onPreview: onPreview, isPreviewing: isPreviewing,
    id: id, x: x, y: y, caption: caption, color: color,
    isNodeBeingDragged: isNodeBeingDragged,
    onBoundingRectUpdated: onBoundingRectUpdate,
    onCaptionUpdated: onCaptionUpdated,
    onPositionUpdate: onPositionUpdate,
    onRemove: onRemove,
    onDetach: onDetach,
    onAppendNew: onAppendNew,
    onAppendRightConnected: onAppendRightConnected,
    onAppendRight: onAppendRight,
    onAppendBottomConnected: onAppendBottomConnected,

    onColorUpdate: onColorUpdate,
    onHover: onHover, onHoverStop: onHoverStop,
    onEdgeConnectionRequest: onEdgeConnectionRequest,
    onBeginDrag: onBeginDrag,
    onBeginDragSubtree: onBeginDragSubtree,
    onEndDrag: onEndDrag,
    onEndDragSubtree: onEndDragSubtree,
    canBeDropTarget: canBeDropTarget,

    onNodeOver: onNodeOver,
    onNodeOverStop: onNodeOverStop,

    disableModifications: disableModifications,

    editOnMount: editOnMount
  });
};

var renderEdge = exports.renderEdge = function renderEdge(_ref2) {
  var id = _ref2.id;
  var color = _ref2.color;
  var highlight = _ref2.highlight;
  var startX = _ref2.startX;
  var startY = _ref2.startY;
  var startDirX = _ref2.startDirX;
  var startDirY = _ref2.startDirY;
  var endX = _ref2.endX;
  var endY = _ref2.endY;
  var endDirX = _ref2.endDirX;
  var endDirY = _ref2.endDirY;
  var onRemove = _ref2.onRemove;
  var disableModifications = _ref2.disableModifications;
  var dashed = _ref2.dashed;
  return _react2.default.createElement(_EdgeView2.default, {
    key: id, id: id, color: color, highlight: highlight, dashed: dashed,
    startX: startX, startY: startY,
    startDirX: startDirX, startDirY: startDirY,
    endX: endX, endY: endY,
    endDirX: endDirX, endDirY: endDirY,

    onRemove: onRemove,
    disableModifications: disableModifications
  });
};

var renderEdges = exports.renderEdges = function renderEdges(_ref3) {
  var graphData = _ref3.graphData;
  var nodesData = _ref3.nodesData;
  var nodeRects = _ref3.nodeRects;
  var draggedNodeOverOther = _ref3.draggedNodeOverOther;
  var draggedNodeId = _ref3.draggedNodeId;
  var canDrop = _ref3.canDrop;
  var disableModifications = _ref3.disableModifications;
  var onRemoveHandler = _ref3.onRemoveHandler;
  return (0, _sceneUtils.getEdgesCoordinates)(nodeRects, graphData, nodesData).map(function (edgeData) {
    var edge = (0, _pureGraph.getEdgeWithId)(edgeData.id, graphData);
    var toNodeId = edge.to;


    var dashed = draggedNodeOverOther && draggedNodeId === toNodeId && canDrop;

    var color = nodesData[toNodeId].color;

    // const highlight = (hoveredNodeId === toNodeId);

    var onRemove = function onRemove() {
      return onRemoveHandler(edgeData.id);
    };

    return renderEdge((0, _xtend2.default)(edgeData, { color: color, highlight: false, onRemove: onRemove, disableModifications: disableModifications, dashed: dashed }));
  });
};

var ProjectScene = (_dec = (0, _reactDnd.DragLayer)(function (monitor) {
  return {
    dragItem: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffsetDifference: monitor.getDifferenceFromInitialOffset(),
    isDragging: monitor.isDragging()
  };
}), _dec(_class = function (_Component) {
  _inherits(ProjectScene, _Component);

  function ProjectScene(props) {
    _classCallCheck(this, ProjectScene);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectScene).call(this, props));

    _this.state = {
      nodeRects: {},

      hoveredNodeId: null,
      hoveredNode: false,

      droppableNodes: [],
      draggedNodeOverOther: false,
      canDrop: false,

      isDraggingNode: false,
      draggingNodeId: null,
      draggingSubTree: false,
      draggingNodeData: { x: 0, y: 0 }
    };
    return _this;
  }

  _createClass(ProjectScene, [{
    key: 'isDraggingNode',
    value: function isDraggingNode() {
      var _props = this.props;
      var isDragging = _props.isDragging;
      var itemType = _props.itemType;
      var dragItem = _props.dragItem;
      var currentOffsetDifference = _props.currentOffsetDifference;

      return isDragging && dragItem && currentOffsetDifference && itemType === _projectDragItemTypes2.default.NODE;
    }
  }, {
    key: 'isDraggingSubTree',
    value: function isDraggingSubTree() {
      // TODO REMAKE
      var _props2 = this.props;
      var itemType = _props2.itemType;
      var dragItem = _props2.dragItem;
      var currentOffsetDifference = _props2.currentOffsetDifference;
      var draggingSubTree = this.state.draggingSubTree;


      return draggingSubTree && dragItem && currentOffsetDifference && itemType === _projectDragItemTypes2.default.NODE_HANDLE;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // prevent drag
      var node = (0, _reactDom.findDOMNode)(this);
      node.addEventListener('mousedown', function (e) {
        e.stopPropagation();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleNodeBoundingRectUpdate = function () {};
    }
  }, {
    key: 'handleNodeHover',
    value: function handleNodeHover() {
      // this.setState({ hoveredNodeId: id, hoveredNode: true });
    }
  }, {
    key: 'handleNodeHoverStop',
    value: function handleNodeHoverStop() {
      // this.setState({ hoveredNodeId: null, hoveredNode: false });
    }
  }, {
    key: 'handleNodeBoundingRectUpdate',
    value: function handleNodeBoundingRectUpdate(id, rect) {
      var newRect = _defineProperty({}, id, rect);
      var newRects = (0, _xtend2.default)(this.state.nodeRects, newRect);

      this.setState({ nodeRects: newRects });
    }
  }, {
    key: 'updateNodeData',
    value: function updateNodeData(id, data) {
      var nodeData = this.props.nodesData[id];
      var newNodeData = _extends({}, nodeData, data);

      this.props.onNodeDataUpdate(id, newNodeData);
    }
  }, {
    key: 'updateNodesData',
    value: function updateNodesData(nodesIds, newNodesData) {
      this.props.onNodesDataUpdate(nodesIds, newNodesData);
    }
  }, {
    key: 'handleNodeCaptionUpdate',
    value: function handleNodeCaptionUpdate(id, caption) {
      this.updateNodeData(id, { caption: caption });
    }
  }, {
    key: 'handleNodePositionUpdate',
    value: function handleNodePositionUpdate(id, _ref4) {
      var x = _ref4.x;
      var y = _ref4.y;

      this.updateNodeData(id, { x: x, y: y });
    }
  }, {
    key: 'handleNodeColorUpdate',
    value: function handleNodeColorUpdate(id, color) {
      this.updateNodeData(id, { color: color });
    }
  }, {
    key: 'handleNodeRemove',
    value: function handleNodeRemove(id) {
      this.props.onNodeRemove(id);
    }
  }, {
    key: 'handleNodeDetach',
    value: function handleNodeDetach(id) {
      this.props.onNodeDetach(id);
    }
  }, {
    key: 'handleNodeAppendNew',
    value: function handleNodeAppendNew(id) {
      this.props.onNodeAppendNew(id);
    }
  }, {
    key: 'getAppendedRightNodePos',
    value: function getAppendedRightNodePos(id) {
      var nodesData = this.props.nodesData;
      var nodeRects = this.state.nodeRects;
      var _nodesData$id = nodesData[id];
      var nodeX = _nodesData$id.x;
      var nodeY = _nodesData$id.y;
      var nodeWidth = nodeRects[id].width;


      var x = nodeX + nodeWidth / 2 + APPEND_RIGHT_PADDING;
      var y = nodeY;

      return { x: x, y: y };
    }
  }, {
    key: 'getAppendedBottomNodePos',
    value: function getAppendedBottomNodePos(id) {
      var nodesData = this.props.nodesData;
      var nodeRects = this.state.nodeRects;
      var _nodesData$id2 = nodesData[id];
      var nodeX = _nodesData$id2.x;
      var nodeY = _nodesData$id2.y;
      var nodeHeight = nodeRects[id].height;


      var x = nodeX;
      var y = nodeY + nodeHeight / 2 + APPEND_BOTTOM_PADDING;

      return { x: x, y: y };
    }
  }, {
    key: 'handleNodeAppendRightConnected',
    value: function handleNodeAppendRightConnected(id) {
      var _getAppendedRightNode = this.getAppendedRightNodePos(id);

      var x = _getAppendedRightNode.x;
      var y = _getAppendedRightNode.y;


      this.props.onNodeAppendRightConnected(id, { x: x, y: y });
    }
  }, {
    key: 'handleNodeAppendRight',
    value: function handleNodeAppendRight(id) {
      var _getAppendedRightNode2 = this.getAppendedRightNodePos(id);

      var x = _getAppendedRightNode2.x;
      var y = _getAppendedRightNode2.y;


      this.props.onNodeAppendRight(id, { x: x, y: y });
    }
  }, {
    key: 'handleNodeAppendBottomConnected',
    value: function handleNodeAppendBottomConnected(id) {
      var _getAppendedBottomNod = this.getAppendedBottomNodePos(id);

      var x = _getAppendedBottomNod.x;
      var y = _getAppendedBottomNod.y;


      this.props.onNodeAppendBottomConnected(id, { x: x, y: y });
    }
  }, {
    key: 'handleEdgeConnectionRequest',
    value: function handleEdgeConnectionRequest(fromId, toId) {
      this.props.onEdgeConnectionRequest(fromId, toId);
    }
  }, {
    key: 'handleEdgeRemove',
    value: function handleEdgeRemove(edgeId) {
      this.props.onEdgeRemove(edgeId);
    }
  }, {
    key: 'handleNodePreview',
    value: function handleNodePreview(nodeId) {
      var _props3 = this.props;
      var canPreviewNode = _props3.canPreviewNode;
      var onNodePreview = _props3.onNodePreview;

      if (!canPreviewNode) return;

      onNodePreview(nodeId);
    }
  }, {
    key: 'handleNodeBeginDrag',
    value: function handleNodeBeginDrag(nodeId) {
      var _this2 = this;

      var graphData = this.props.graphData;


      (0, _raf2.default)(function () {
        var droppableNodes = getDroppableNodes(nodeId, graphData);
        _this2.setState({ droppableNodes: droppableNodes });
      });
    }
  }, {
    key: 'handleNodeEndDrag',
    value: function handleNodeEndDrag() {
      this.setState({ droppableNodes: [] });
    }
  }, {
    key: 'handleNodeBeginDragSubTree',
    value: function handleNodeBeginDragSubTree() {
      this.setState({
        droppableNodes: [],
        draggingSubTree: true
      });
    }
  }, {
    key: 'handleNodeEndDragSubTree',
    value: function handleNodeEndDragSubTree(id, _ref5) {
      var dx = _ref5.dx;
      var dy = _ref5.dy;

      this.setState({
        droppableNodes: [],
        draggingSubTree: false
      });

      var _props4 = this.props;
      var graphData = _props4.graphData;
      var nodesData = _props4.nodesData;


      var draggedNodes = (0, _pureGraph.getNodesOfSubgraphFrom)(this.getDraggedNodeId(), graphData);

      var draggedNodesIds = (0, _pureGraph.getNodesOfSubgraphFrom)(id, graphData);
      var draggedNodesData = draggedNodesIds.map(function (nodeId) {
        return _extends({ id: nodeId }, nodesData[nodeId]);
      });
      var shiftedNodesData = this.getShiftedNodesData(draggedNodesData, { dx: dx, dy: dy });

      this.updateNodesData(draggedNodes, shiftedNodesData);
    }
  }, {
    key: 'handleNodeOver',
    value: function handleNodeOver(id) {
      var _this3 = this;

      (0, _raf2.default)(function () {
        var droppableNodes = _this3.state.droppableNodes;


        _this3.setState({
          draggedNodeOverOther: true,
          canDrop: droppableNodes.indexOf(id) > -1
        });
      });
    }
  }, {
    key: 'handleNodeOverStop',
    value: function handleNodeOverStop() {
      this.setState({
        draggedNodeOverOther: false,
        canDrop: false
      });
    }
  }, {
    key: 'getDraggedNodeId',
    value: function getDraggedNodeId() {
      if (!this.props.dragItem) return null;
      var id = this.props.dragItem.id;


      return id;
    }
  }, {
    key: 'getDraggedNodesIds',
    value: function getDraggedNodesIds() {
      var graphData = this.props.graphData;


      if (this.isDraggingSubTree()) {
        return [].concat(_toConsumableArray((0, _pureGraph.getNodesOfSubgraphFrom)(this.getDraggedNodeId(), graphData)), [this.getDraggedNodeId()]);
      }

      if (this.isDraggingNode()) {
        return [this.getDraggedNodeId()];
      }

      return [];
    }
  }, {
    key: 'getShiftedNodesData',
    value: function getShiftedNodesData(modifiedNodesData, _ref6) {
      var dx = _ref6.dx;
      var dy = _ref6.dy;
      var nodesData = this.props.nodesData;


      var shiftedData = modifiedNodesData.map(function (data) {
        return _extends({}, data, {
          x: data.x + dx,
          y: data.y + dy
        });
      }).reduce(function (res, nodeData) {
        return _extends({}, res, _defineProperty({}, nodeData.id, nodeData));
      }, {});

      return _extends({}, nodesData, shiftedData);
    }
  }, {
    key: 'getNodesData',
    value: function getNodesData() {
      var nodesData = this.props.nodesData;


      var draggedNodesIds = this.getDraggedNodesIds();
      if (draggedNodesIds.length === 0) return nodesData;

      // handle dragging nodes case
      var currentOffsetDifference = this.props.currentOffsetDifference;
      var dx = currentOffsetDifference.x;
      var dy = currentOffsetDifference.y;


      var draggedNodesData = draggedNodesIds.map(function (id) {
        return _extends({ id: id }, nodesData[id]);
      });
      return this.getShiftedNodesData(draggedNodesData, { dx: dx, dy: dy });
    }
  }, {
    key: 'renderNodes',
    value: function renderNodes(_ref7) {
      var _this4 = this;

      var graphData = _ref7.graphData;
      var nodesData = _ref7.nodesData;
      var previewingNode = _ref7.previewingNode;
      var previewingNodeId = _ref7.previewingNodeId;
      var disableModifications = _ref7.disableModifications;
      var droppableNodes = _ref7.droppableNodes;
      var editNodesOnMount = _ref7.editNodesOnMount;

      var nodeIds = (0, _pureGraph.getNodes)(graphData);
      var renderedNodes = nodeIds.map(function (id) {
        return { id: id, data: nodesData[id] };
      }).filter(function (_ref8) {
        var data = _ref8.data;
        return !!data;
      }).map(function (_ref9) {
        var id = _ref9.id;
        var data = _ref9.data;
        return renderNode({
          id: id, data: data,

          isNodeBeingDragged: _this4.isDraggingNode(),
          onCaptionUpdated: _this4.handleNodeCaptionUpdate.bind(_this4, id),
          onBoundingRectUpdate: _this4.handleNodeBoundingRectUpdate.bind(_this4, id),
          onRemove: _this4.handleNodeRemove.bind(_this4, id),
          onPositionUpdate: _this4.handleNodePositionUpdate.bind(_this4, id),
          onColorUpdate: _this4.handleNodeColorUpdate.bind(_this4, id),
          onDetach: _this4.handleNodeDetach.bind(_this4, id),
          onAppendNew: _this4.handleNodeAppendNew.bind(_this4, id),
          onAppendRight: _this4.handleNodeAppendRight.bind(_this4, id),
          onAppendRightConnected: _this4.handleNodeAppendRightConnected.bind(_this4, id),
          onAppendBottomConnected: _this4.handleNodeAppendBottomConnected.bind(_this4, id),
          onHover: _this4.handleNodeHover.bind(_this4, id),
          onHoverStop: _this4.handleNodeHoverStop.bind(_this4, id),
          onEdgeConnectionRequest: function onEdgeConnectionRequest(from) {
            return _this4.handleEdgeConnectionRequest(from, id);
          },
          onPreview: _this4.handleNodePreview.bind(_this4, id),
          isPreviewing: previewingNode && previewingNodeId === id,

          onBeginDrag: _this4.handleNodeBeginDrag.bind(_this4, id),
          onEndDrag: _this4.handleNodeEndDrag.bind(_this4, id),

          onBeginDragSubtree: _this4.handleNodeBeginDragSubTree.bind(_this4, id),
          onEndDragSubtree: _this4.handleNodeEndDragSubTree.bind(_this4, id),

          canBeDropTarget: droppableNodes.indexOf(id) > -1,

          onNodeOver: _this4.handleNodeOver.bind(_this4, id),
          onNodeOverStop: _this4.handleNodeOverStop.bind(_this4, id),

          disableModifications: disableModifications, editOnMount: editNodesOnMount
        });
      });

      return renderedNodes;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props;
      var graphData = _props5.graphData;
      var previewingNode = _props5.previewingNode;
      var previewingNodeId = _props5.previewingNodeId;
      var disableModifications = _props5.disableModifications;
      var editNodesOnMount = _props5.editNodesOnMount;
      var _state = this.state;
      var nodeRects = _state.nodeRects;
      var hoveredNodeId = _state.hoveredNodeId;
      var draggedNodeOverOther = _state.draggedNodeOverOther;
      var droppableNodes = _state.droppableNodes;
      var canDrop = _state.canDrop;


      var usedNodesData = this.getNodesData();

      return _react2.default.createElement(
        'div',
        null,
        renderEdges({
          nodeRects: nodeRects, graphData: graphData, nodesData: usedNodesData, hoveredNodeId: hoveredNodeId, disableModifications: disableModifications,
          draggedNodeOverOther: draggedNodeOverOther, canDrop: canDrop,
          draggedNodeId: this.getDraggedNodeId(),
          onRemoveHandler: this.handleEdgeRemove.bind(this)
        }),
        this.renderNodes({
          graphData: graphData, nodesData: usedNodesData,
          previewingNode: previewingNode, previewingNodeId: previewingNodeId,
          disableModifications: disableModifications, droppableNodes: droppableNodes, editNodesOnMount: editNodesOnMount
        })
      );
    }
  }]);

  return ProjectScene;
}(_react.Component)) || _class);
exports.default = ProjectScene;


ProjectScene.propTypes = {
  graphData: _react.PropTypes.object.isRequired,
  nodesData: _react.PropTypes.object.isRequired,

  onNodeDataUpdate: _react.PropTypes.func.isRequired,
  onNodesDataUpdate: _react.PropTypes.func.isRequired,
  onNodeRemove: _react.PropTypes.func.isRequired,
  onNodePreview: _react.PropTypes.func.isRequired,
  onNodeDetach: _react.PropTypes.func.isRequired,
  onNodeAppendNew: _react.PropTypes.func.isRequired,
  onNodeAppendRightConnected: _react.PropTypes.func.isRequired,
  onNodeAppendRight: _react.PropTypes.func.isRequired,
  onNodeAppendBottomConnected: _react.PropTypes.func.isRequired,

  onEdgeConnectionRequest: _react.PropTypes.func.isRequired,
  onEdgeRemove: _react.PropTypes.func.isRequired,

  canPreviewNode: _react.PropTypes.bool,
  previewingNode: _react.PropTypes.bool,
  previewingNodeId: _react.PropTypes.string,

  disableModifications: _react.PropTypes.bool,
  editNodesOnMount: _react.PropTypes.bool
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/ProjectScene.js
// module id = 600
// module chunks = 1